// import React from "react"
import { formatLink } from "@/components/terra/utils/formatLink"
import { formatFocusedImage } from "@/lib/formatters/formatFocusedImage"
import Link from "next/link"

// ProductDetailPage / ProductTrialPage now have a required `slug` field. Check
// those types before the generic slug → formatLink path, otherwise they'd be
// treated as normal pages (/{locale}/{slug}) instead of
// /{locale}/products/{slug}/buy|trial.
function resolvePromoUrl(data: any, currentLocale: string, homepageSlug: string): string | null {
  if (data?.pageLink?.__typename === "ContentfulExternalLink") {
    return data?.pageLink?.url
  }
  if (data?.pageLink?.__typename === "ContentfulProductTrialPage" && data?.pageLink?.slug) {
    return `/${currentLocale}/products/${data.pageLink.slug}/trial`
  }
  if (data?.pageLink?.__typename === "ContentfulProductDetailPage" && data?.pageLink?.slug) {
    return `/${currentLocale}/products/${data.pageLink.slug}/buy`
  }
  if (data?.pageLink?.slug) {
    return (
      formatLink(
        `/${data.pageLink.slug}`,
        currentLocale,
        data.pageLink.__typename,
        homepageSlug,
      ) ?? null
    )
  }
  return null
}

export const formatNavPromo = (
  data: any,
  homepageSlug: string,
  currentLocale: string,
) => {
  const returnData = {
    id: data?.id,
    pageLink: {
      external:
        data?.pageLink?.__typename === "ContentfulExternalLink" ? true : false,
      url: resolvePromoUrl(data, currentLocale, homepageSlug),
      text: data?.pageLinkLabel || "Read more",
    },
    title: data?.title,
    image: formatFocusedImage(data?.image),
    description: data?.description,
    Link: Link,
  }
  return returnData
}
